<script>
import { mapState, mapGetters } from 'vuex'
import Validation from '@/plugins/validation'
import catBreeds from '@/data/catBreeds'
import dogBreeds from '@/data/dogBreeds'
import species from '@/data/species'
import couponCodes from '@/data/couponCodes'
import track from '@/plugins/track'

export default {
  name: 'AddPet',
  props: ['index', 'pet'],
  data() {
    return {
      catBreeds,
      dogBreeds,
      species,
      couponCodes,
      showDate: false,
      ...Validation,
    }
  },
  computed: {
    ...mapState({
      plans: state => state.plans,
    }),
    breeds() {
      let breeds
      this.pet.species == 'Cat' ? breeds = catBreeds : breeds = dogBreeds
      return breeds
    },
    // I DON'T BELIEVE COUPONRULESARRAY IS UTILIZED
    // couponRulesArray() {
    //   let rules = [...this.couponRules]
    //   if (this.pet.apaId) {
    //     rules = [ ...this.couponRules, ...this.required ]
    //   }
    //   return rules
    // },
  },
  methods: {
    deletePet() {
      this.$store.dispatch('signup/DELETE_PET', this.index)
      track({
        event: 'click',
        category: 'signup',
        action: 'deletepet',
        label: 'DeletePetClicked',
      })
    },
    allowedDates(val) {
      let today = new Date();
      let currentTime = Date.parse(today);
      let dob = Date.parse(val);
      if (dob <= currentTime) {
        return val;
      }
    }
  }
}
</script>

<template>
  <div class="addPetContainer">
    <v-row >
      <v-col md="4" cols="12">
        <v-text-field v-model="pet.name" :rules="[...nameRules, ...required]" outlined light label="Pet's First Name"></v-text-field>
      </v-col>

      <v-col style="position:relative;" md="4" cols="12">
        <v-text-field 
          :rules="required" 
          v-model="pet.dob" 
          label="D.O.B"
          @focus="showDate = true"
          outlined 
          light>
        </v-text-field>

        <v-date-picker 
          type="month" 
          v-model="pet.dob" 
          class="d-inline" 
          v-if="showDate" 
          @change="showDate = false" 
          :allowed-dates="allowedDates" 
          light>
        </v-date-picker>
      </v-col>

      <v-col md="4" cols="12">
        <v-autocomplete v-model="pet.species" :rules="required" outlined light :items="species" label="Species" @change="pet.breed=''"></v-autocomplete>
      </v-col>
    </v-row>

    <v-row>
      <v-col md="6" cols="12">
        <v-autocomplete v-model="pet.breed" :rules="required" outlined light :items="breeds" label="Breed"  ></v-autocomplete>
      </v-col>

      <v-col md="6" cols="12">
        <v-select v-model="pet.plan" :rules="required" required outlined light :items="plans.map(plan => { return { value: plan, text: `${ plan.name } - $${ plan.costPerMonth }*/mo` } })" label="Plan*"></v-select>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-expansion-panels light flat>
          <v-expansion-panel >

            <v-expansion-panel-header expand-icon="">
              <template >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span class="highlighted">Have a coupon code?</span>
                  </v-col>
                </v-row>
              </template>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <v-row>

                <v-col cols="12" md="6">
                  <v-text-field v-model="pet.couponCode" :rules="couponRules" placeholder="Enter Coupon Code"></v-text-field>
                </v-col>

              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>

    <v-divider light class="mb-4"></v-divider>

    <v-row align="center" justify="center" class="mt-0">
      <v-col class="pt-0" v-if="index > 0" md="12" cols="12" align="right" align-self="center">
        <v-btn class="orangebtn" large @click="deletePet">Remove Pet <v-icon class="ml-4">mdi-minus-box</v-icon></v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss" scoped>

  .v-input,
  .v-input__control,
  .v-input__slot {
    height: 56px;
  }

  .deletebtn {
    margin-top: 16px;
  }
  .deletebtn:hover {
    color: red;
  }
  .deletebtn-big {
    display: none;
  }

  .highlighted {
    font-size: 16px;
    color: #06abc9;
    text-decoration: underline;
    cursor: pointer;
  }

  @media only screen and (max-width: 960px) {
    .addPetContainer {
      margin-bottom: 16px;
      padding: 8px;
      border-radius: 4px;
      box-shadow: 3px 3px 4px 1px #AAA;
      border: solid 1px #AAA;
    }
    .deletebtn {
      display: none;
    }
    .deletebtn-big {
      display: block;
    }
  }

</style>
